/* ============================================================================
   Artline PAINT MARKER LP - main script (artline_paint_marker.js, adapted)
   Source: Artlinemarker/js/artline_paint_marker.js - kept verbatim except:
   - [C2] dead language-switcher handlers removed (their DOM was removed in
     the US adaptation of the reference HTML)
   - guards added so the script cannot throw while the page's sections are
     added incrementally (#global-nav lives in the mainvisual section;
     smooth-scroll targets may not exist yet)
   ========================================================================== */
jQuery(function () {
  //スムーススクロール
  $('a[href^="#"]').click(function() {
    // スクロールの速度
    let speed = 400; // ミリ秒で記述
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    if (!target.length) { return false; }
    var winW = $(window).width();
    var devW = 767;
    // Sticky store header added 2026-09-10; 0 when absent or not pinned.
    var chromeH = typeof window.LPStickyChromeOffset === 'function' ? window.LPStickyChromeOffset() : 0;
    if (winW <= devW) {
      //767px以下の時の処理
      var position = target.offset().top - 50 - chromeH;
    } else {
      //768pxより大きい時の処理
      var position = target.offset().top - 80 - chromeH;
    }
    $('body,html').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });

  // ヘッダー
  let headNav = $('header');
  //scrollしたとき
  $(window).on('scroll', function () {
    if($(this).scrollTop() > 80 && headNav.hasClass('fixed') == false) {
  headNav.addClass('fixed');
  }
    else if($(this).scrollTop() <= 80 && headNav.hasClass('fixed') == true){
    headNav.removeClass('fixed');
  }
  });

  // ハンバーガーメニュー開閉
  (function () {
    $('.js-buttonHamburger').click(function () {
      $('body').toggleClass('is-drawerActive');

      if ($('#js-buttonHamburger').attr('aria-expanded') == 'false') {
        scrollPosition = $(window).scrollTop();
        $(this).attr('aria-expanded', true);
        $("body").css({ top: -scrollPosition });
      } else {
        $(this).attr('aria-expanded', false);
        window.scrollTo(0, scrollPosition);
      }
    });
    $('.js-drawer-close').click(function () {
      $('#js-buttonHamburger').attr('aria-expanded', false);
    });
  }) ();

  // 動画
  (function () {
    if ($(".js-modal-video").length) {
      $(".js-modal-video").modalVideo({
        channel: "youtube",
        youtube: {
          rel: 0, //関連動画の指定
          autoplay: 1, //自動再生の指定
          controls: 0, //コントロールさせるかどうかの指定
        },
      });
    }
  })();

  // タブ切り替え
  $('.tab-content>div').hide();
  $('.tab-content>div').first().slideDown();
  $('.tab-buttons span').click(function(){
    var thisclass=$(this).attr('class');
    $('.tab-content>div').each(function(){
      if($(this).hasClass(thisclass)){
        $(this).fadeIn(800);
      }
      else{
        $(this).hide();
      }
    });
  });
  $('.tab-buttons span').click(function(){
    $('.tab-buttons span').removeClass('current');
    $(this).addClass('current');
  });

  //カラーチップ
  var searchBox = '.check_list'; // 絞り込む項目を選択するエリア
  var listItem = '.list_item';   // 絞り込み対象のアイテム
  var hideClass = 'is_hide';     // 絞り込み対象外の場合に付与されるclass名
  $(function() {
    // 絞り込み項目を変更した時
    $(document).on('change', searchBox + ' input', function() {
      search_filter();
    });
    $(document).ready(function() {
      search_filter();
    });
  });
  // リストの絞り込み処理
  function search_filter() {
    // $('fade_list').fadeIn();
    // 非表示状態を解除
    $(listItem).removeClass(hideClass).fadeIn();
    for (var i = 0; i < $(searchBox).length; i++) {
      var name = $(searchBox).eq(i).find('input').attr('name');
      // 選択されている項目を取得
      var searchData = get_selected_input_items(name);
      // 選択されている項目がない、またはALLを選択している場合は飛ばす
      if(searchData.length === 0 || searchData[0] === '') {
        continue;
      }
      // リスト内の各アイテムをチェック
      for (var j = 0; j < $(listItem).length; j++) {
        // アイテムに設定している項目を取得
        var itemData = get_setting_values_in_item($(listItem).eq(j), name);
        // 絞り込み対象かどうかを調べる
        var check = array_match_check(itemData, searchData);
        if(!check) {
          $(listItem).eq(j).addClass(hideClass).fadeOut();
          // $(listItem).eq(j).fadeOut();
        }
      }
    }
  }
  // inputで選択されている値の一覧を取得する
  function get_selected_input_items(name) {
    var searchData = [];
    $('[name=' + name + ']:checked').each(function() {
      searchData.push($(this).val());
    });
    return searchData;
  }
  // リスト内のアイテムに設定している値の一覧を取得する
  function get_setting_values_in_item(target, data) {
  var itemData = target.data(data);
  if(!Array.isArray(itemData)) {
  itemData = [itemData];
  }
  return itemData;
  }
  // 2つの配列内で一致する文字列があるかどうかを調べる
  function array_match_check(arr1, arr2) {
    // 絞り込み対象かどうかを調べる
    var arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
      if(arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
      }
    }
    return arrCheck;
  }

  //カラーチップ02
  var searchBox02 = '.check_list02'; // 絞り込む項目を選択するエリア
  var listItem02 = '.list_item02';   // 絞り込み対象のアイテム
  var hideClass02 = 'is_hide02';     // 絞り込み対象外の場合に付与されるclass名
  $(function() {
    // 絞り込み項目を変更した時
    $(document).on('change', searchBox02 + ' input', function() {
      search_filter02();
    });
    $(document).ready(function() {
      search_filter02();
    });
  });
  // リストの絞り込み処理
  function search_filter02() {
    $('fade_list').fadeIn();
    // 非表示状態を解除
    $(listItem02).removeClass(hideClass02);
    for (var i = 0; i < $(searchBox02).length; i++) {
      var name02 = $(searchBox02).eq(i).find('input').attr('name');
      // 選択されている項目を取得
      var searchData02 = get_selected_input_items(name02);
      // 選択されている項目がない、またはALLを選択している場合は飛ばす
      if(searchData02.length === 0 || searchData02[0] === '') {
        continue;
      }
      // リスト内の各アイテムをチェック
      for (var j = 0; j < $(listItem02).length; j++) {
        // アイテムに設定している項目を取得
        var itemData02 = get_setting_values_in_item($(listItem02).eq(j), name02);
        // 絞り込み対象かどうかを調べる
        var check02 = array_match_check(itemData02, searchData02);
        if(!check02) {
          $(listItem02).eq(j).addClass(hideClass02);
          // $(listItem).eq(j).fadeOut();
        }
      }
    }
  }

  //カラーチップ03
  var searchBox03 = '.check_list03'; // 絞り込む項目を選択するエリア
  var listItem03 = '.list_item03';   // 絞り込み対象のアイテム
  var hideClass03 = 'is_hide03';     // 絞り込み対象外の場合に付与されるclass名
  $(function() {
    // 絞り込み項目を変更した時
    $(document).on('change', searchBox03 + ' input', function() {
      search_filter03();
    });
    $(document).ready(function() {
      search_filter03();
    });
  });
  // リストの絞り込み処理
  function search_filter03() {
    $('fade_list').fadeIn();
    // 非表示状態を解除
    $(listItem03).removeClass(hideClass03);
    for (var i = 0; i < $(searchBox03).length; i++) {
      var name03 = $(searchBox03).eq(i).find('input').attr('name');
      // 選択されている項目を取得
      var searchData03 = get_selected_input_items(name03);
      // 選択されている項目がない、またはALLを選択している場合は飛ばす
      if(searchData03.length === 0 || searchData03[0] === '') {
        continue;
      }
      // リスト内の各アイテムをチェック
      for (var j = 0; j < $(listItem03).length; j++) {
        // アイテムに設定している項目を取得
        var itemData03 = get_setting_values_in_item($(listItem03).eq(j), name03);
        // 絞り込み対象かどうかを調べる
        var check03 = array_match_check(itemData03, searchData03);
        if(!check03) {
          $(listItem03).eq(j).addClass(hideClass03);
          // $(listItem).eq(j).fadeOut();
        }
      }
    }
  }

  //カラーチップ04
  var searchBox04 = '.check_list04'; // 絞り込む項目を選択するエリア
  var listItem04 = '.list_item04';   // 絞り込み対象のアイテム
  var hideClass04 = 'is_hide04';     // 絞り込み対象外の場合に付与されるclass名
  $(function() {
    // 絞り込み項目を変更した時
    $(document).on('change', searchBox04 + ' input', function() {
      search_filter04();
    });
    $(document).ready(function() {
      search_filter04();
    });
  });
  // リストの絞り込み処理
  function search_filter04() {
    $('fade_list').fadeIn();
    // 非表示状態を解除
    $(listItem04).removeClass(hideClass04);
    for (var i = 0; i < $(searchBox04).length; i++) {
      var name04 = $(searchBox04).eq(i).find('input').attr('name');
      // 選択されている項目を取得
      var searchData04 = get_selected_input_items(name04);
      // 選択されている項目がない、またはALLを選択している場合は飛ばす
      if(searchData04.length === 0 || searchData04[0] === '') {
        continue;
      }
      // リスト内の各アイテムをチェック
      for (var j = 0; j < $(listItem04).length; j++) {
        // アイテムに設定している項目を取得
        var itemData04 = get_setting_values_in_item($(listItem04).eq(j), name04);
        // 絞り込み対象かどうかを調べる
        var check04 = array_match_check(itemData04, searchData04);
        if(!check04) {
          $(listItem04).eq(j).addClass(hideClass04);
          // $(listItem).eq(j).fadeOut();
        }
      }
    }
  }

  // アコーディオン
  $('.js_accordion_ttl').on('click',function(){
    $(this)
      .toggleClass('is_active')
      .next('.js_accordion_body')
      .slideToggle()
  });

  if ( jQuery( '#global-nav' ).length ) {
    var navPos = jQuery( '#global-nav' ).offset().top; // グローバルメニューの位置
    // var navHeight = jQuery( '#global-nav' ).outerHeight(); // グローバルメニューの高さ
    jQuery( window ).on( 'scroll', function() {
      if ( jQuery( this ).scrollTop() > navPos ) {
        // jQuery( 'body' ).css( 'padding-top', navHeight );
        jQuery( '#global-nav' ).addClass( 'm_fixed' );
      } else {
        jQuery( 'body' ).css( 'padding-top', 0 );
        jQuery( '#global-nav' ).removeClass( 'm_fixed' );
      }
    });
  }
});
window.onload = function () {
  var set = 81;//ウインドウ上部からどれぐらいの位置で変化させるか
  var boxTop = new Array;
  var current = -1;
  //各要素の位置
  $('.js-box').each(function(i) {
  boxTop[i] = $(this).offset().top;
  });
  //最初の要素にclass="on"をつける
  changeBox(0);
  //スクロールした時の処理
  $(window).scroll(function(){
  scrollPosition = $(window).scrollTop();
  for (var i = boxTop.length - 1 ; i >= 0; i--) {
  if ($(window).scrollTop() > boxTop[i] - set) {
  changeBox(i);
  break;
  }
  };
  });
  //ナビの処理
  function changeBox(secNum) {
  if (secNum != current) {
  current = secNum;
  secNum2 = secNum ;//HTML順序用
  $('#nav li').removeClass('on');
  $('#nav li:nth-child(' + secNum2 +')').addClass('on');
  /* 位置によって個別に処理をしたい場合
  if (current == 0) {
  // 現在地がsection1の場合の処理
  } else if (current == 1) {
  // 現在地がsection2の場合の処理
  } else if (current == 2) {
  // 現在地がsection3の場合の処理
  }*/
  }
  };
};

$(function () {
    const ua = navigator.userAgent;
    if (ua.indexOf('iPhone') > -1 || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1)) {
        $(".mv").addClass("mv_sp");
    } else if (ua.indexOf('iPad') > -1 || ua.indexOf('Android') > -1) {
        // タブレット
        $(".mv").addClass("mv_tab");
    } else {
        $(".mv").addClass("mv_pc");
    }
})
